import React from 'react';
import { urlWithoutProtocolRegExHash } from 'helpers/regExs';
import { Box } from 'rebass/styled-components';

export const useCompaniesFormValidation = (validateName = true) => {
  const getInvalidDomains = (domains) =>
    domains.filter((domain) => domain && domain.length).filter((domain) => !urlWithoutProtocolRegExHash.test(domain));

  const onFormValidation = (values) => {
    const { name } = values;

    const domains = values.domains.split(/[\n,]+/);

    if (validateName && !name) {
      return { name: 'Required' };
    }

    if (!domains.length || !domains.filter((domain) => domain.trim().length > 0).length) {
      return { domains: 'Required' };
    }

    if (domains.length > 1000) {
      return { domains: 'Lists can have up to 1,000 companies. Consider breaking this list into smaller ones.' };
    }

    const invalidDomains = getInvalidDomains(domains.map((domain) => domain.trim()));

    if (invalidDomains.length) {
      return {
        domains: (
          <Box>
            <Box>Please review the format of the following websites:</Box>
            <Box as="ul" pl="24px" sx={{ listStyleType: 'disc' }}>
              {invalidDomains.map((domain) => (
                <Box as="li" key={domain}>
                  {domain}
                </Box>
              ))}
            </Box>
          </Box>
        ),
      };
    }

    return {};
  };

  return { onFormValidation };
};
